<script lang="ts">
  export let sectionClass = '';
  export let panel1Container = '';
  export let panel2Container = '';
  export let panel1Variant = '';
  export let panel2Variant = '';
  export let richTextContainer = '';
</script>

<section class={sectionClass}>
  <div class="{panel1Container} {panel1Variant}">
    <div class={richTextContainer}>
      <slot name="panel1" />
    </div>
  </div>
  <div class="{panel2Container} {panel2Variant}">
    <div class={richTextContainer}>
      <slot name="panel2" />
    </div>
  </div>
</section>
